// extracted by mini-css-extract-plugin
export default {"dot-spinner":"DotSpinner_dot-spinner__uHCgW","dot":"DotSpinner_dot__mgrZk","pulse":"DotSpinner_pulse__nUuco"};